// The base constants that all derived objects will receive

const baseConstants = ['ALERT_OVERRIDE', 'SHOW_CANCEL', 'CHANGE', 'CREATE', 'CREATE_FAIL', 'CREATE_SUCCESS', 'CHANGE', 'CHANGE_ADD', 'CHANGE_QUIETLY', 'CHANGE_PATCH', 'CHANGE_CONTENT', 'CHANGE_REMOVE', 'CLEAR_PENDING', 'DESTROY', 'DESTROY_SUCCESS', 'DESTROY_FAIL', 'DUPLICATE_SUCCESS', 'DUPLICATE_FAIL', 'DISABLE_SAVE', 'ENABLE_SAVE', 'ERROR_DOES_NOT_EXIST', 'SET_EDITOR_CACHE_VALUE', 'SET_EDITOR_CACHE_VALUES', 'FILTER', 'FILTER_CLEAR', 'FILTER_SELECTED', 'NOOP', 'INDEX', 'INDEX_CANCEL', 'INDEX_SUCCESS', 'INDEX_FAIL', 'PAGE_INIT', 'PAGE_NEXT', 'PAGE_PREVIOUS', 'OPERATION_PENDING', 'OPERATION_COMPLETE', 'SAVE', 'SAVE_ALL', 'SAVE_ALL_FAIL', 'SAVE_ALL_SUCCESS', 'SAVE_FAIL', 'SAVE_SUCCESS', 'SEARCH', 'SELECT', 'SELECT_ALL', 'SELECT_CLEAR', 'SELECT_CLEAR_ALL', 'SELECT_INDEX', 'SELECT_INDEX_CLEAR', 'SELECT_INDEX_FAILURE', 'SELECT_INDEX_SUCCESS', 'SHOW', 'SHOW_SUCCESS', 'SHOW_FAIL', 'UNDO_CHANGES', 'UPLOAD_ALL', 'UPLOAD_CLEAR', 'UPLOAD_FAILURE', 'UPLOAD_SUCCESS', 'SERVER_SAVE_STATUS'];
const registry = {};

/*
 * Creates the constant object using each baseConstant prefixed
 * i.e. constant =
 * { CHANGE: 'ASSET_CHANGE', INDEX_SUCCESS: 'ASSET_INDEX_SUCCESS',  ... }
 */
export function tableConstantsFactory(prefix) {
  const constants = {};
  for (let i = 0, len = baseConstants.length; i < len; i += 1) {
    constants[baseConstants[i]] = `${prefix.toUpperCase()}_${baseConstants[i]}`;
  }
  registry[prefix] = constants;
  return constants;
}

/* this looks up all the constant instances in a registry and returns
 *  them based on entity name.  Could separate the mapping of entity
 *  from PREFIX registry lookup here, but at this point there is no reason to.
 */
export function constantsRegistry(entity) {
  let prefix = '';
  let result = null;
  switch (entity) {
    case 'Creator':
      prefix = 'EMPLOYEE';
      break;
    case 'ContractSpec':
      prefix = 'CONSPEC';
      break;
    case 'JobPhaseCode':
      prefix = 'JOB_PHASE_CODE';
      break;
    default:
      prefix = entity.toUpperCase();
  }
  if (registry[prefix]) {
    result = registry[prefix];
  } else if (!result || result.length === 0) {
    result = tableConstantsFactory(prefix);
  }
  return result;
}